import { useCallback } from 'react';
import defaultImageHandler, {
  setDefaultImage
} from '~/utilities/defaultImageHandler';

// Server-rendered images can fail before hydration, when onError isn't attached yet, so also check on mount.
export default function useDefaultImageFallback() {
  const ref = useCallback((image: HTMLImageElement | null) => {
    if (image?.complete && image.naturalWidth === 0) {
      setDefaultImage(image);
    }
  }, []);

  return { onError: defaultImageHandler, ref };
}
